import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/hooks/use-toast";

export const useReviewActions = () => {
  const queryClient = useQueryClient();

  const markHelpful = useMutation({
    mutationFn: async (reviewId: string) => {
      const { data, error } = await supabase
        .from('product_reviews')
        .select('helpful_count')
        .eq('id', reviewId)
        .single();

      if (error) throw error;

      const { error: updateError } = await supabase
        .from('product_reviews')
        .update({ helpful_count: (data.helpful_count || 0) + 1 })
        .eq('id', reviewId);

      if (updateError) throw updateError;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['product-reviews'] });
      toast({
        title: "Thank you!",
        description: "Your feedback helps other customers.",
      });
    },
    onError: () => {
      toast({
        title: "Action Failed",
        description: "Unable to mark review as helpful.",
        variant: "destructive",
      });
    },
  });

  return { markHelpful };
};
